<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">数据详情</p>
      <div class="search">
        <div>
          <div class="search-detail">
            <div class="options">
              <Button
                type="ghost"
                icon="ios-undo"
                @click="back"
              >返回</Button>
            </div>
            <div class="sp">
              <Button type="primary" class="search-button">导出</Button>
            </div>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table">
        <Table stripe ref="table" :loading="listLoading" :columns="columns" :data="list"></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      id: ''
    }
  },
  computed: {
    ...mapState('table', ['pageSizeOpts']),
    columns() {
      const allColumns = [
        {
          title: '',
          type: 'selection',
          fixed: 'left',
          width: 60,
        },
        {
          title: '序号',
          type: 'index',
        },
        {
          title: '提交时间',
          key: 'create_time',
          width: 140,
        },
        {
          title: '答题时长',
          key: 'time_cost',
          width: 140,
          render: (h, {row}) => {
          	return h('span', this.second(row.time_cost))
          }
        },
        {
          title: '浏览器',
          key: 'browser',
          width: 140,
        },
        {
          title: '操作系统',
          key: 'operating_system',
          width: 140,
        },
        {
          title: '用 户 IP',
          key: 'ip',
          width: 140,
        },
        {
          title: '开始时间',
          key: 'start_time',
          width: 140,
        },
        {
          title: '结束时间',
          key: 'end_time',
          width: 200,
        },
        {
          title: '答题状态',
          key: 'state',
          width: 140,
          render: (h, {row}) => {
          	return h('span', [row.state === 1 ? '已回答' : ''])
          }
        },
        {
          title: '操作',
          key: '',
          fixed: 'left',
          render: (h, { row }) => {
            const button = [
              h(
                'Button',
                {
                  nativeOn: {
                    click: () => this.jump(row)
                  },
                  style: {
                    marginRight: '10px',
                  },
                },
                '查看'
              ),
              h(
                'Button',
                {
                  nativeOn: {
                    click: () =>
                      this.jump()
                  }
                },
                '导出'
              ),
            ]
            return h('div', button)
          },
        },
      ]
      allColumns.forEach((v) => (v.align = 'center'))
      return allColumns
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.loadList()
  },
  methods: {
    second(value) {
        let theTime = parseInt(value)// 秒
        let middle = 0// 分
        if (theTime > 60) {
            middle = parseInt(theTime / 60)
            theTime = parseInt(theTime % 60)
            if (middle > 60) {
                middle = parseInt(middle % 60)
            }
        }
        let result = '' + parseInt(theTime) + '秒'
        if (middle > 0) {
            result = '' + parseInt(middle) + '分' + result
        }
        return result
    },
    jump(row) {
      console.log(row)
      this.$router.push({
        name: 'answerDetails',
        query: {
          id: row.id,
          index: row._index
        }
      })
    },
    back () {
      this.$router.back()
    },
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/answer/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              fk_t_bo_survey_id: this.id
            },
          }),
          this.$http.get('/answer/count', {
            params: {
              fk_t_bo_survey_id: this.id
            }
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    }
  },
}
</script>
<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .sp {
    width: 100%;
    text-align: right;
  }

  .search-detail {
    display: flex;
    // flex-wrap: wrap;
    margin-top: 20px;
    // height: 90px;
    transition: 0.5s;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/questionnaire/answer/index.vue